import React from 'react';
import Icon, { type IconName } from '../Icon';
import { channelVars, type Channel } from '../../utils/channel';

interface Props {
  icon: IconName;
  label: string;
  value: string;
  /** Channel tint for the icon tile; defaults to brand emerald. */
  channel?: Channel;
  delta?: { dir: 'up' | 'down'; text: string };
}

const StatTile: React.FC<Props> = ({ icon, label, value, channel, delta }) => {
  const tint = channel
    ? channelVars(channel)
    : { color: 'var(--brand-600)', soft: 'var(--brand-50)' };
  return (
    <div className="stat">
      <div className="stat-ico" style={{ background: tint.soft, color: tint.color }}>
        <Icon name={icon} size={20} />
      </div>
      <div className="stat-label">{label}</div>
      <div className="stat-value tnum">{value}</div>
      {delta && (
        <div className={`stat-delta ${delta.dir}`}>
          <Icon name={delta.dir === 'up' ? 'arrowUp' : 'arrowDown'} size={14} />
          {delta.text}
        </div>
      )}
    </div>
  );
};

export default StatTile;
